export const convertWhitespaceToPlusInSlug = (slug: string) => {
  return slug?.replace(/\s/g, "+");
};
